module.exports = __webpack_public_path__ + "images/category_lp/trading_card/store_images/4_1f2acec91571b2fa5e5e022f3cdb2eac.png";